import {Class} from './class.js';

export var Store = new Class(/** @lends Store.prototype */{
	/**
	 * Creates a Redux like store object.
	 * @constructs
	 * @param {Object} state - The application state.
	 * @param {Function} reducer - A callback called when an action is dispatched.
	 */
	constructor: function(state, reducer){
		this._state = state;
		this._reducer = reducer;
		this._listeners = [];
		this._dispatching = false;
		this._dispatchQueue = [];
	},

	/**
	 * Gets the current state.
	 * @return {Object} The state object.
	 */
	getState: function(){
		return this._state;
	},

	/**
	 * Dispatches an action.
	 * @param {Object} action - An object describing the action.
	 * @param {String} action.type - An action type.
	 */
	dispatch: function(action){
		this._dispatchQueue.push(action);

		if (this._dispatching) return;

		this._dispatching = true;

		var localAction;

		while ((localAction = this._dispatchQueue.shift())){
			var state = this._state = this._reducer(localAction, this._state);

			this._listeners.forEach(function(listener){
				listener(state);
			});
		}

		this._dispatching = false;
	},

	/**
	 * Adds a callback for state changes.
	 * @param  {Function} listener - A function that will be called with the 
	 * new state.
	 */
	subscribe: function(listener){
		this._listeners[this._listeners.length] = listener;
	},

	unsubscribe: function(listener){
		this._listeners = this._listeners.filter(function(fn){
			return fn !== listener;
		});
	}
});